module.exports = __webpack_public_path__ + "img/infibo-how-to-buy-a-license-en-2.a6d8bca1.png";